<template>
  <main>
    <ticker-admin-nav />
    <h4>Universal Security Master</h4>
    <h5>Options</h5>

    <article class="row">
      <section class="input-field col s4">
        <input id="search-option-by-osi-symbol"
               type="text"
               name="search"
               placeholder="e.g. GOOGL200619C00230000"
               v-model="osiSymbol"
               @keyup.enter="fetchOption()"
        >
        <label class="active" for="search-option-by-osi-symbol">
          Search by OSI Symbol
        </label>
        <span class="helper-text left teal-text text-lighten-3">
          <strong>Type and hit "Enter"</strong>
        </span>
      </section>
      <section class="col s8" />
    </article>

    <loader v-if="isLoading" />
    <table v-else>
      <thead>
        <tr>
          <th v-show="$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')" />
          <th>ID</th>
          <th>Underlying</th>
          <th>Exchange</th>
          <th>$trike Price</th>
          <th>Type</th>
          <th>Expiration Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="option of options" :key="option.id">
          <td v-show="$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')">
            <router-link :to="`/tickeradmin/editoption?option_id=${option.id}`">
              <i class="far fa-edit clickable amber-text big" />
            </router-link>
          </td>
          <td>{{ option.id }}</td>
          <td>
              {{ option.underlying_instrument_parent.symbol || '-' }}
          </td>
          <td>{{ option.exchange.symbol }}</td>
          <td>${{ option.strike_price | round }}</td>
          <td>
            <span class="new badge deep-purple accent-2" data-badge-caption="Put" v-if="option.is_put" />
            <span class="new badge deep-orange accent-2" data-badge-caption="Call" v-else />
          </td>
          <td>{{ option.expiration_date }}</td>
        </tr>
      </tbody>
    </table>

      <ul class="pagination">
        <li class="page-btn clickable" @click="selectedPage === 1 ? selectedPage = 1 : selectedPage -= 1" >
          <i class="material-icons">chevron_left</i>
        </li>
        <div v-if="selectedPage <= 5">
          <li class="waves-effect page-btn"
              :class="selectedPage === pageNum ? 'active' : ''"
              :key="pageNum"
              v-for="pageNum in 5" @click="selectedPage = pageNum">
            {{ pageNum }}
          </li>
          <li class="dots">...</li>
          <li class="page-btn" @click="selectedPage = totalPages - 1"> {{ totalPages - 1 }} </li>
          <li class="page-btn" @click="selectedPage = totalPages"> {{ totalPages }} </li>
        </div>
        <div v-if="selectedPage >= totalPages - 5">
          <li class="page-btn" @click="selectedPage = 1"> 1 </li>
          <li class="page-btn" @click="selectedPage = 2"> 2 </li>
          <li class="dots">...</li>
          <li class="waves-effect page-btn"
              :class="selectedPage === pageNum ? 'active' : ''"
              :key="pageNum"
              v-for="pageNum in lastPages" @click="selectedPage = pageNum">
            {{ pageNum }}
          </li>
        </div>
        <div v-if="selectedPage > 5 && selectedPage < totalPages - 5">
          <li class="page-btn" @click="selectedPage = 1"> 1 </li>
          <li class="page-btn" @click="selectedPage = 2"> 2 </li>
          <li class="dots">...</li>
          <li class="waves-effect page-btn active"
              >
            {{ selectedPage }}
          </li>
          <li class="dots">...</li>
          <li class="page-btn" @click="selectedPage = totalPages - 1"> {{ totalPages - 1 }} </li>
          <li class="page-btn" @click="selectedPage = totalPages"> {{ totalPages }} </li>
        </div>
        <li class="waves-effect clickable page-btn" @click="selectedPage === totalPages ? selectedPage = totalPages : selectedPage += 1">
          <i class="material-icons">chevron_right</i>
        </li>
      </ul>

    <aside class="usm-add-option-aside">
      <router-link to="/tickeradmin/addoption" v-show="$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')">
        <button id="usm-add-option-btn"
                class="btn-large btn-floating waves-effect waves-light teal accent-4"
        >
          <i class="fas fa-plus" />
        </button>
        <label for="usm-add-option-btn">Add Option</label>
      </router-link>
    </aside>
  </main>
</template>

<script>
import axios from 'axios';
import TickerAdminNav from '@/components/TickerAdminNav.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'TickerAdminListOptions',
  components: { TickerAdminNav, Loader },
  props: {},
  data() {
    return {
      isLoading: false,
      options: [],
      currentPage: 0,
      totalPages: 0,
      selectedPage: 1,
      osiSymbol: '',
    };
  },
  computed: {
    lastPages() {
      let arr = Array(this.totalPages+1)
      let newArr = Array.from(arr.keys())
      return newArr.slice(this.totalPages-5, this.totalPages+1)
    },
  },
  watch: {
    async selectedPage() {
      await this.fetchOptions();
    },
  },
  methods: {
    async fetchOptions() {
      this.isLoading = true;
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/options/?page=${this.selectedPage}`);
      this.options = data.options;
      this.currentPage = data.current_page;
      this.totalPages = data.total_pages;
      this.isLoading = false;
    },
    async fetchOption() {
      this.isLoading = true;
      try {
        const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/option/?osi_symbol=${this.osiSymbol}`);
        this.options = [data];
      } catch (exception) {
        if (exception.response.status === 404) {
          this.toast('Option not found', 'orange');
        }
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.fetchOptions();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.usm-add-option-aside {
  position: absolute;
  top: 100px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}

.pagination {
  display: inline-flex;
}

.page-btn {
  margin: 0 5px;
  font-size: 1.2rem;
  cursor: pointer;
  background: gainsboro;
  padding: 0 5px;
}

.dots {
  margin: 0 5px;
  cursor: default;
}

</style>
